import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import HomePage from './pages/HomePage';
import ListingsPage from './pages/ListingsPage';
import ListingDetailPage from './pages/ListingDetailPage';
import AddListingPage from './pages/AddListingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MyListingsPage from './pages/MyListingsPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AdminPage from './pages/AdminPage';
import RegulaminPage from './pages/RegulaminPage';
import PrywatnoscPage from './pages/PrywatnoscPage';
import AboutPage from './pages/AboutPage';
import RenewPage from './pages/RenewPage';
import NotFoundPage from './pages/NotFoundPage';
import usePlausible from './hooks/usePlausible';

function Inner() {
  usePlausible();
  return (
    <AuthProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ogloszenia" element={<ListingsPage />} />
        <Route path="/ogloszenia/:slug" element={<ListingDetailPage />} />
        <Route path="/dodaj" element={<AddListingPage />} />
        <Route path="/logowanie" element={<LoginPage />} />
        <Route path="/rejestracja" element={<RegisterPage />} />
        <Route path="/moje-ogloszenia" element={<MyListingsPage />} />
        <Route path="/weryfikacja-email" element={<VerifyEmailPage />} />
        <Route path="/zapomniane-haslo" element={<ForgotPasswordPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/regulamin" element={<RegulaminPage />} />
        <Route path="/prywatnosc" element={<PrywatnoscPage />} />
        <Route path="/o-nas" element={<AboutPage />} />
        <Route path="/przedluz/:token" element={<RenewPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
      <CookieBanner />
    </AuthProvider>
  );
}

export default function App() {
  return <Inner />;
}
